import { Anchor, Button, Stack, Text, TextInput } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line @typescript-eslint/no-require-imports
const dinlabeldistribuidores = require("url:../assets/DinLabelDistribuidores.pdf");

export function NeedToRegister() {
  const { t } = useTranslation();

  return (
    <Stack gap="md">
      <Anchor href={dinlabeldistribuidores}>
        {t("portal.distributorInfo")}
      </Anchor>
      <Text>{t("register.intro")}</Text>
      <form id="form" action="/distributor/signup" method="post">
        <Stack gap="sm">
          <TextInput
            label={t("register.company")}
            id="companyName"
            name="companyName"
            placeholder={t("register.companyPlaceholder")}
          />
          <TextInput
            label={t("register.phone")}
            id="phoneNumber"
            name="phoneNumber"
            placeholder={t("register.phonePlaceholder")}
            description={t("register.phoneDescription")}
          />
          <TextInput
            label={t("register.street")}
            id="street"
            name="street"
            placeholder={t("register.street1Placeholder")}
          />
          <TextInput
            label={t("register.street")}
            id="street2"
            name="street2"
            placeholder={t("register.street2Placeholder")}
          />
          <TextInput
            label={t("register.number")}
            id="number"
            name="number"
            placeholder={t("register.number")}
          />
          <TextInput
            label={t("register.city")}
            id="city"
            name="city"
            placeholder={t("register.city")}
          />
          <TextInput
            label={t("register.state")}
            id="state"
            name="state"
            placeholder={t("register.state")}
          />
          <TextInput
            label={t("register.country")}
            id="country"
            name="country"
            placeholder={t("register.country")}
          />
          <TextInput
            label={t("register.zip")}
            id="zip"
            name="zip"
            placeholder={t("register.zip")}
          />
          <TextInput
            label={t("register.rfc")}
            id="businessId"
            name="businessId"
            placeholder={t("register.rfc")}
          />
          <Text c="dimmed" size="sm">
            {t("register.nextSteps")}
          </Text>
          <Button type="submit">{t("register.submit")}</Button>
        </Stack>
      </form>
    </Stack>
  );
}
